import React from 'react';
import { Section, SectionHeading } from './Shared';
const costs = [{
  without: 'Sin estructura de sesión',
  cost: 'Improvisación que el paciente percibe'
}, {
  without: 'Sin series por patología',
  cost: 'Cada sesión armada desde cero'
}, {
  without: 'Sin protocolo de protección',
  cost: 'Absorbes la carga del paciente'
}, {
  without: 'Sin planificación anual',
  cost: 'Trabajo reactivo, sin estrategia'
}, {
  without: 'Sin ficha clínica',
  cost: 'Consultas sin registro ni continuidad'
}];
export const CostComparison = () => <Section data-id="element-21" data-mp="2pl3pkwnn26n3">
    <SectionHeading eyebrow="El costo de esperar" className="mb-8" data-id="element-22" data-mp="2pkki69vm70nb">
      ¿Cuánto cuesta no tenerlo?
    </SectionHeading>

    <div className="max-w-3xl mx-auto glass-panel rounded-sm overflow-hidden divide-y divide-brand-purpleDark/10" data-id="element-23" data-mp="2klhccn7t8qea">
      {costs.map(row => <div key={row.without} className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-4 px-5 py-2.5" data-id="element-24" data-mp="1973qfnwmal0w">
          <p className="text-sm font-medium text-brand-purpleDark sm:w-1/2" data-id="element-25" data-mp="2lbu256btgfk6">
            {row.without}
          </p>
          <p className="text-sm text-brand-burgundy/90 sm:w-1/2" data-id="element-26" data-mp="2pbukv35y7cx1">
            {row.cost}
          </p>
        </div>)}
    </div>

    <p className="text-center mt-8 max-w-2xl mx-auto text-lg md:text-xl font-display italic text-brand-purpleDark" data-id="element-27" data-mp="2gbpmfiiqfov0">
      “Quien tiene un sistema aplica con confianza. Quien aplica con confianza,
      crece.”
    </p>
  </Section>;